module.exports = __webpack_public_path__ + "static/team-1-77a9f509436f77d1baa5a58b8e74f0dd.jpg";